import { CssBaseline } from '@mui/material';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Home from './pages/Home';

ReactDOM.render(
  <React.StrictMode>
    <CssBaseline />
    <Home />
  </React.StrictMode>,
  document.getElementById('root')
);